import { assoc, chain } from 'icepick'

const initialState = {
  services: [],
  servicesLoading: false,
}

export const hostedVoiceReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'HOSTED_VOICE/LIST_SERVICES_PENDING':
      return assoc(state, 'servicesLoading', true)

    case 'HOSTED_VOICE/LIST_SERVICES_FULFILLED':
      return chain(state)
        .assoc('servicesLoading', false)
        .assoc('services', action.payload.data)
        .value()

    case 'HOSTED_VOICE/LIST_SERVICES_REJECTED':
      return assoc(state, 'servicesLoading', false)

    default:
      return state
  }
}



// WEBPACK FOOTER //
// src/features/Services/HostedVoice/HostedVoice.reducer.ts